import React from "react";
import { useTranslation } from "react-i18next";
import { combinedYears, visibleTeam } from "../content/team";
import "../styles/home.css";

/**
 * Team #team (spec c.7 §5): two principals as an editorial spread, not cards.
 * Every number comes from src/content/team.ts. Hiding a principal (visible: false)
 * collapses the spread to one column and updates {{years}} by itself.
 */
const Team: React.FC = () => {
  const { t } = useTranslation();
  const people = visibleTeam();
  if (people.length === 0) return null;

  return (
    <section id="team" className="section" aria-labelledby="team-heading">
      <div className="container">
        <header className="section-head">
          <p className="t-label">{t("team.label")}</p>
          <h2 id="team-heading">{t("team.title")}</h2>
          <p className="t-lead">{t("team.lead", { years: combinedYears() })}</p>
        </header>

        <div className={`people${people.length === 1 ? " people--single" : ""}`}>
          {people.map((m) => (
            <article key={m.key} className="person" aria-labelledby={`person-${m.key}`}>
              <div className="person-head">
                <span className="monogram person-monogram" aria-hidden="true">
                  {m.photo ? <img src={m.photo} alt="" width={96} height={96} /> : m.initials}
                </span>
                <div className="person-id">
                  <h3 id={`person-${m.key}`}>{t(`team.${m.key}.name`)}</h3>
                  <p className="person-role">{t(`team.${m.key}.role`)}</p>
                  <p className="t-small person-years">{t("team.yearsLine", { n: m.years })}</p>
                </div>
              </div>
              <p className="person-bio">{t(`team.${m.key}.bio`, { n: m.years })}</p>
              <ul className="chips person-codes" aria-label={t("team.modulesLabel")}>
                {m.codes.map((code) => (
                  <li key={code} className="chip">
                    {code}
                  </li>
                ))}
              </ul>
              <p className="t-small person-industries">
                <span className="person-industries-label">{t("team.industriesLabel")}:</span>{" "}
                {t(`team.${m.key}.industries`)}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
